import {
  ComponentFactoryResolver,
  ComponentRef,
  Type,
  ViewContainerRef
} from '@angular/core';
import { OnView } from '../../../../model/tabs/on-view';

export class ClientProjectDetailTab {
  title: string;
  oldPlatformIdTitle: string = '';
  componentClass: Type<OnView<string>>;
  component?: ComponentRef<OnView<string>>;
  inputs: any;
  subProjectExecutedForClient: boolean;
  viewContainer: ViewContainerRef;

  constructor(
    title: string,
    componentClass: Type<OnView<string>>,
    inputs: any,
    subProjectExecutedForClient: boolean
  ) {
    this.title = title;
    this.componentClass = componentClass;
    this.inputs = inputs;
    this.subProjectExecutedForClient = subProjectExecutedForClient;
  }

  createComponentView(
    componentFactoryResolver: ComponentFactoryResolver,
    target?: ViewContainerRef
  ) {
    if (target != null) {
      this.viewContainer = target;
    }
    this.component = this.createComponent(
      this.componentClass,
      this.inputs,
      componentFactoryResolver,
      this.viewContainer
    );
  }

  private createComponent(
    componentClass: Type<OnView<string>>,
    inputs: any,
    componentFactoryResolver: ComponentFactoryResolver,
    view: ViewContainerRef
  ): ComponentRef<OnView<string>> {
    const factory = componentFactoryResolver.resolveComponentFactory(
      componentClass
    );
    const newComponent = factory.create(view.injector);
    if (inputs) {
      Object.keys(inputs).map(key => {
        newComponent.instance[key] = inputs[key];
      });
    }
    return newComponent;
  }

  closeTab() {
    if (this.component != null) {
      this.component.destroy();
    }
  }
}
